import React from 'react';
import Image from '../../components/common/Image';
import Link from 'next/link';

type Props = {};

const BannerPromoCatalogItem = (props: Props) => {
  return (
    <Link href={'/occasion/mothers-day/'}>
      <div>
        <Image
          width={1140}
          height={90}
          src={
            'https://cart.gourmetbasket.com.au/wp-content/uploads/2024/04/mothers-day-hamper-horizontal-banner-scaled.jpg'
          }
          alt={'Easter Corp'}
          className=""
        />
      </div>
    </Link>
  );
};

export default BannerPromoCatalogItem;
